import { getPlayValueIndexesFromArray } from '@/utils/misc';

/**
 * Defines the index position of each value inside a player stat play.
 * @module playerStatsPlayIndexes
 */
const playerStatPlayValues = [
  'playId',
  'gameId',
  'playerId',
  'momentOfPlay',
  'categoryId',
  'categoryType',
  'matchLapse',
  'section',
  'matchResult', // 1=Gano, 2=Perdio, 3=Empato
  'playingAs',
  'total',
  'coordinate1X',
  'coordinate1Y',
  'coordinate2X',
  'coordinate2Y',
  'coordinate3X',
  'coordinate3Y',
  'xGi',
  'xGf',
];

let playerStatPlayIndex = null;

export default function getPlayerStatPlayIndexes() {
  if (!playerStatPlayIndex) {
    playerStatPlayIndex = getPlayValueIndexesFromArray(playerStatPlayValues);
  }
  return playerStatPlayIndex;
}
